import {} from "./IStatsController";
import { Configuration, EarningsApi, StatsApi } from "../gen/adprovisioning/index";
import { getAuthInfo } from "../utility/AccountUtility";
import { Totals } from "../model/StatsTotals";
export class DefaultStatsController {
    backendUrl;
    constructor(backendUrl) {
        this.backendUrl = backendUrl;
    }
    getStatsApi() {
        let authInfo = getAuthInfo();
        return new StatsApi(new Configuration({
            accessToken: authInfo.getToken(),
            basePath: this.backendUrl
        }));
    }
    getEarningsApi() {
        let authInfo = getAuthInfo();
        return new EarningsApi(new Configuration({
            accessToken: authInfo.getToken(),
            basePath: this.backendUrl
        }));
    }
    async getTotalEarningForBooking(bookingId) {
        let api = this.getEarningsApi();
        let netEarnings = await api.earningsBookingBookingIdTotalGet({
            bookingId: bookingId
        });
        return netEarnings.total;
    }
    async getDailyEarnings(bookingId, from, to) {
        let api = this.getEarningsApi();
        let resultApi = await api.earningsBookingBookingIdGet({
            bookingId: bookingId,
            from: from,
            to: to,
            aggregation: "1d"
        });
        let resultingMap = new Map();
        for (let key in resultApi) {
            let time = new Date(key);
            resultingMap.set(time, resultApi[key]);
        }
        return resultingMap;
    }
    async getImpressionStatsForBookingPerIsoCountry(bookingId, from, to) {
        let api = this.getStatsApi();
        let result = {};
        result = await api.statsBookingBookingIdGeolocationGet({
            bookingId: bookingId,
            from: from,
            to: to
        });
        return result;
    }
    async getImpressionStatsForBooking(bookingId, from, to, groupingInterval) {
        let api = this.getStatsApi();
        let result = await api.statsBookingBookingIdGet({
            bookingId: bookingId,
            from: from,
            to: to,
            aggregation: groupingInterval
        });
        let convertedResult = new Map();
        for (let key in result) {
            let total = new Totals();
            let netTotal = result[key];
            let time = new Date(key);
            total.CountImpressions = netTotal.countImpressions;
            total.CountUniquePlayers = netTotal.countUniquePlayers;
            total.DurationS = netTotal.durationS;
            convertedResult.set(time, total);
        }
        return convertedResult;
    }
    async getImpressionStatsForSlot(slotId, from, to, groupingInterval) {
        let api = this.getStatsApi();
        let result = await api.statsSlotSlotIdGet({
            slotId: slotId,
            from: from,
            to: to,
            aggregation: groupingInterval
        });
        let convertedResultBooked = new Map();
        let convertedResultUnBooked = new Map();
        for (let key in result.booked) {
            let total = new Totals();
            let netTotal = result.booked[key];
            let time = new Date(key);
            total.CountImpressions = netTotal.countImpressions;
            total.CountUniquePlayers = netTotal.countUniquePlayers;
            total.DurationS = netTotal.durationS;
            convertedResultBooked.set(time, total);
        }
        for (let key in result.unbooked) {
            let total = new Totals();
            let netTotal = result.unbooked[key];
            let time = new Date(key);
            total.CountImpressions = netTotal.countImpressions;
            total.CountUniquePlayers = netTotal.countUniquePlayers;
            total.DurationS = netTotal.durationS;
            convertedResultUnBooked.set(time, total);
        }
        convertedResultBooked = new Map([...convertedResultBooked.entries()].sort());
        convertedResultUnBooked = new Map([...convertedResultUnBooked.entries()].sort());
        return {
            booked: convertedResultBooked,
            unbooked: convertedResultUnBooked
        };
    }
    async getImpressionStatsForSlotPerIsoCountry(slotId, from, to) {
        let api = this.getStatsApi();
        let result = {};
        result = await api.statsSlotSlotIdGeolocationtotalGet({
            slotId: slotId,
            from: from,
            to: to
        });
        return result;
    }
    async getTotalsForBooking(bookingId) {
        let api = this.getStatsApi();
        let netTotals = await api.statsBookingBookingIdTotalsGet({
            bookingId: bookingId
        });
        let result = new Totals();
        result.CountImpressions = netTotals.countImpressions;
        result.CountUniquePlayers = netTotals.countUniquePlayers;
        result.DurationS = netTotals.durationS;
        return result;
    }
    convertOpenapiMapResultToMap(result) {
        let convertedResult = new Map();
        for (let key in result) {
            let time = new Date(key);
            convertedResult.set(time, result[key]);
        }
        return convertedResult;
    }
    async getBookingImpressionDurations(bookingId, from, to, groupingInterval) {
        let api = this.getStatsApi();
        let result = await api.statsBookingBookingIdAggregateddurationGet({
            bookingId: bookingId,
            from: from,
            to: to,
            aggregation: groupingInterval,
        });
        let convertedResult = new Map();
        for (let key in result) {
            let time = new Date(key);
            convertedResult.set(time, result[key]);
        }
        return new Map([...convertedResult.entries()].sort());
    }
    async getSlotImpressionDurations(slotId, from, to, groupingInterval) {
        let api = this.getStatsApi();
        let result = await api.statsSlotSlotIdAggregateddurationGet({
            slotId: slotId,
            from: from,
            to: to,
            aggregation: groupingInterval,
        });
        let convertedResultBooked = new Map();
        for (let key in result.booked) {
            let time = new Date(key);
            convertedResultBooked.set(time, result.booked[key]);
        }
        let convertedResultUnbooked = new Map();
        for (let key in result.unbooked) {
            let time = new Date(key);
            convertedResultUnbooked.set(time, result.unbooked[key]);
        }
        return {
            booked: new Map([...convertedResultBooked.entries()].sort()),
            unbooked: new Map([...convertedResultUnbooked.entries()].sort()),
        };
    }
}
